import Pattern from "@assets/PNG/Patterns/Pattern2.png";
import ChevronRight from "@assets/SVG/ChevronRight.svg";
import MAHBLogo from "@assets/SVG/Logos/MAHB.svg";
import Logo from "@assets/SVG/Logos/MAHBBig.svg";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useAuth } from "~/Hooks/useAuth";
import { Roles } from "~/Utils/Roles";

const airportModules = [
  {
    name: "klia1",
    label: "KLIA Terminal 1",
    backgroundColor: "lightYellow",
    logo: MAHBLogo,
    content: "Main international terminal offering a premium travel experience with top-notch facilities.",
  },
  {
    name: "klia2",
    label: "KLIA Terminal 2",
    backgroundColor: "secondary-100",
    logo: MAHBLogo,
    content: "Modern terminal catering to low-cost carriers, ensuring a seamless passenger journey.",
  },
  {
    name: "kota-kinabalu",
    label: "Kota Kinabalu",
    backgroundColor: "secondary-100",
    logo: MAHBLogo,
    content: "Modern terminal catering to low-cost carriers, ensuring a seamless passenger journey.",
  },
  {
    name: "kuching",
    label: "Kuching",
    backgroundColor: "lightBlue",
    logo: MAHBLogo,
    content: "A key East Malaysian hub connecting the region with domestic and international destinations.",
  },
  {
    name: "langkawi",
    label: "Langkawi",
    backgroundColor: "lightBlue",
    logo: MAHBLogo,
    content: "Gateway to Malaysia’s island paradise, known for efficiency and beautiful surroundings.",
  },
  {
    name: "penang",
    label: "Penang",
    backgroundColor: "lightYellow",
    logo: MAHBLogo,
    content: "A key East Malaysian hub connecting the region with domestic and international destinations.",
  },
];

export const PassengerAirports = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [currentAirport, setCurrentAirport] = useLocalStorage("currentAirport", null);

  useEffect(() => {
    console.log("currentAirport useEffect", currentAirport);
    if (currentAirport) {
      navigate(`/dedicated/${currentAirport.toLowerCase()}/dashboard`, { replace: true });
      // if (user?.role === Roles.SUPER_ADMIN || user?.role === Roles.PASSENGER_ECMS_REVIEWER) {
      //   navigate(`/dedicated/passenger/approval-management?activeTab=pending`, { replace: true });
      // } else if (user?.role === Roles.PASSENGER_ECMS_CREATOR) {
      //   navigate(`/dedicated/passenger/homepage?activeTab=sliders`, { replace: true });
      // } else {
      //   // Fallback for other passenger roles if they ever hit this page
      //   navigate(`/dedicated/passenger/butterfly-effect`, { replace: true });
      // }
    }
  }, [currentAirport, navigate, user?.role]);

  // ✅ All users can see all airports
  const allowedAirports = airportModules;

  return (
    <div className="px-20 py-8 relative">
      <img
        src={Pattern}
        className="absolute top-0 right-0"
        alt="Pattern"
      />
      <img
        src={Logo}
        className="h-16"
        alt="Logo"
      />

      <h1 className="text-lg font-semibold text-pink mt-6">Select Airport</h1>
      <p className="text-sm font-normal text-neutral-1 mb-5">Let&apos;s get started! Select the airport to continue</p>

      <div className="grid grid-cols-2 gap-10 mt-10">
        {allowedAirports.map((airport) => (
          <div
            key={airport.name}
            onClick={() => {
              console.log("Selected Airport:", airport.name);
              setCurrentAirport(airport.name);
            }}
            className={`relative flex items-center gap-8 cursor-pointer rounded-2xl bg-${airport.backgroundColor} p-6 shadow`}
          >
            <img
              src={airport.logo}
              className="w-14 h-14"
              alt={airport.label}
            />
            <div className="relative flex-1">
              <h2 className="text-lg font-semibold text-darkBlue">{airport.label}</h2>
              <p className="text-sm font-normal text-darkBlue max-w-[396px]">
                {airport.content || "No description available for this airport."}
              </p>
              <div className="w-7 h-7 absolute right-0 bottom-0 p-1 bg-white flex items-center justify-center rounded-full">
                <img
                  src={ChevronRight}
                  className="w-4 h-4"
                  alt="Chevron Right"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
